import { useCallback } from 'react'
import { FormattedMessage } from 'react-intl'
import Box from '@mui/material/Box'
import Typography from '@mui/material/Typography'
import Button from '@mui/material/Button'
import { get, keyBy } from 'lodash'
import PageSectionList from '../../../../shared/components/layouts/PageSectionList'

const IngressControllersSection = ({ ingressControllers, services, networks, onCreateClick, onEditClick }) => {
  const servicesById = keyBy(services, 'id')
  const networksById = keyBy(networks, 'id')

  const renderItem = useCallback((ingressController) => {
    const service = get(servicesById, ingressController.serviceId)
    const network = get(networksById, ingressController.networkId)
    const serviceName = get(service, 'name', 'Unknown')
    const networkName = get(network, 'name', 'Unknown')

    return {
      primary: <Typography variant="body1">{ingressController.name}</Typography>,
      secondary: (
        <Box sx={{ mt: 0.5 }}>
          <Typography variant="caption" color="text.secondary" component="span">
            <FormattedMessage id="ingressControllers.serviceLabel" />: {serviceName}
          </Typography>
          <Typography variant="caption" color="text.secondary" component="span" sx={{ ml: 2 }}>
            <FormattedMessage id="ingressControllers.networkLabel" />: {networkName}
          </Typography>
        </Box>
      )
    }
  }, [servicesById, networksById])

  return (
    <>
      <Box sx={{ display: 'flex', justifyContent: 'flex-end', mb: 1 }}>
        <Button
          variant="outlined"
          size="small"
          onClick={onCreateClick}
        >
          <FormattedMessage id="ingressControllers.createButton" />
        </Button>
      </Box>
      <PageSectionList
        items={ingressControllers}
        emptyId="ingressControllers.empty"
        renderItem={renderItem}
        onItemEdit={onEditClick}
      />
    </>
  )
}

export default IngressControllersSection
